import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import QuizQuestion from "../../components/StudentPortal/Quiz/QuizQuestion";
import Error from "../../components/ui/Error";
import { useAddQuizMarkMutation } from "../../features/quizMark/quizMarkApi";
import { useGetQuizForVideoQuery } from "../../features/quizzes/quizzesApi";
import { useGetVideoQuery } from "../../features/videos/videosApi";

export default function Quiz() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data: quizzes,
    isLoading,
    isError,
    error,
  } = useGetQuizForVideoQuery(id) || {};

  const { data: video } = useGetVideoQuery(id) || {};
  const { user } = useSelector((state) => state.auth);

  const [
    addQuizMark,
    {
      isLoading: addLoading,
      isError: addError,
      isSuccess,
      error: addErrorMessage,
    },
  ] = useAddQuizMarkMutation();

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleOptionChange = (quizIndex, optionIndex, checked) => {
    setSelectedOptions((prevSelectedOptions) => ({
      ...prevSelectedOptions,
      [quizIndex]: {
        ...prevSelectedOptions[quizIndex],
        [optionIndex]: checked,
      },
    }));
  };

  useEffect(() => {
    if (isSuccess) {
      navigate("/leaderboard");
    }
  }, [isSuccess, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();

    let totalCorrect = 0;
    let totalWrong = 0;

    Object.keys(selectedOptions).forEach((quizIndex) => {
      const selectedOptionIndex = Object.keys(selectedOptions[quizIndex]).find(
        (optionIndex) => selectedOptions[quizIndex][optionIndex]
      );

      if (
        selectedOptionIndex !== undefined &&
        quizzes[quizIndex].options[selectedOptionIndex].isCorrect
      ) {
        totalCorrect++;
      } else {
        totalWrong++;
      }
    });

    let totalQuiz = quizzes.length;
    let totalMark = quizzes.length * 5;
    let mark = totalCorrect * 5;

    addQuizMark({
      data: {
        student_id: user.id,
        student_name: user.name,
        video_id: video.id,
        video_title: video.title,
        totalQuiz,
        totalCorrect,
        totalWrong,
        totalMark,
        mark,
      },
    });
  };

  let content = null;

  if (isLoading) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        Loading...
      </div>
    );
  } else if (!isLoading && isError) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && quizzes?.length === 0) {
    content = (
      <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
        No Videos Found!
      </div>
    );
  } else if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((quiz, index) => {
      return (
        <QuizQuestion
          key={quiz.id}
          quiz={quiz}
          index={index}
          onOptionChange={handleOptionChange}
          selectedOptions={selectedOptions[index]}
        />
      );
    });
  }
  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="mb-8">
            <h1 className="text-2xl font-bold">
              Quizzes for "Debounce Function in JavaScript - JavaScript Job
              Interview question"
            </h1>
            <p className="text-sm text-slate-200">
              Each question contains 5 Mark
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {content}

            <button
              disabled={addLoading}
              className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
            >
              Submit
            </button>
          </form>
          {addError && <Error message={addErrorMessage?.data} />}
        </div>
      </section>
    </>
  );
}
